import React, { memo } from 'react';
import { Image } from 'react-bootstrap';
import { Images } from '../../app-constants';

interface NoResultGradientImageProps {
  height?: number;
  width?: number;
}

const NoResultGradientImage: React.FC<NoResultGradientImageProps> = memo(
  ({ width, height }) => (
    <Image
      src={Images.NoResultGradient}
      alt="no-result-gradient"
      height={height}
      width={width}
    />
  ),
);

export default NoResultGradientImage;
